import React from 'react';
import { connect } from 'react-redux';

import { changeFormField } from 'apps/auth/actions/formAction';
import AddPhoto from 'apps/auth/components/common/AddPhoto/AddPhoto';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';

const UploadDocImg = (props) => {
    return (
        <div key={`doc_${props.field.name}`}>
            <Row indent="24px">
                <Text size="subheader" color="secondary">
                    {props.field.placeholder}
                </Text>
            </Row>
            <AddPhoto field={props.field} formName={props.formName} />
        </div>
    );
};

export default connect(null, { changeFormField })(UploadDocImg);
